import { Injectable, Provider } from "@angular/core";
import { Observable, forkJoin, of } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { AuthService as MainAuthService, AuthType, IDENEDI_CODE_STORAGE_KEY, AuthService } from "src/app/shared/services/auth.service";
import { IStemexeModule } from "../data-providers/interfaces/interfaces";
import { StemexeDataProviderService } from "../data-providers/services/stemexe-data-provider.service";
import { DataProvider, PagedData, PagedDataItem } from "../data-providers/models/models";
import { environment } from "src/environments/environment";
import { HigherAuthService } from "../shared/services/higher-auth.service";

//EspDataProviderService class and it's usage is only for demo purpose.
@Injectable({
  providedIn: "root"
})
export class HigherDataProviderService implements IStemexeModule {
  type: AuthType = AuthType.Higher;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private _authService: MainAuthService,
    private higherAuthSrevice: HigherAuthService
  ) {
  }

  initialize(): void {
  }

  getDataProviders(providerType: string): Observable<DataProvider[]> {
    let espDataProviders: DataProvider[] = [];
    if (providerType == 'ActivitySource') {
      // return of([])
      return this._authService.getAuthAddonByType(AuthType.Higher).pipe(
        switchMap(addon => {
          this.higherAuthSrevice.registerUserOnHigher();
          let pDataProvider: DataProvider = new DataProvider();
          pDataProvider.title = 'Higher';
          pDataProvider.id = '6';
          pDataProvider.system = addon?.BaseUrl
          pDataProvider.tenantId = addon?.OrganziationId;
          pDataProvider.getData = (token, isAll) => {
            return this._getProviderData(pDataProvider, token, isAll)
          }
          espDataProviders.push(pDataProvider);
          return of(espDataProviders);
        }));
    }
  }
  private _getProviderData(provider: DataProvider, nextPageToken?: any, isAll?: any): Observable<PagedData> {
    // console.log('token', nextPageToken)
    if (provider.id === '6') {
      const projectPayload = {
        keyword: '',
        pageNumber: 1,
        pageSize: 1000
      };
      const url = `${provider.system}/api/Project/get-all-project`;
      return this.http.get(url, this.higherAuthSrevice.getHeader()).pipe(
        map((result: any) => {

          const pagedData = new PagedData();
          result.unshift({
            id: '-1',
            title: 'None',
            isSimpleProject: false
          });

          pagedData.items = result.map((r: any) => {
            let item1 = new PagedDataItem();
            item1.id = r.id;
            item1.extraData = {}
            item1.title = r.title,
              item1.url = '/pages/client/project/' + r.id;
            item1.getData = (nextPageToken) => this._getNextData(provider, item1, nextPageToken);
            item1.isSimpleProject = r.isSimpleProject;
            return item1;
          })
          return pagedData;
        })
      );
    }
    else {
      let pagedData = new PagedData();
      return of(pagedData);
    }
  }
  private _getNextData(provider: DataProvider, pagedDataItem: PagedDataItem, nextPageToken?: any) {
    const data = {
      keyword: '',
      pageNumber: 1,
      pageSize: 1000,
      projectId: pagedDataItem.id
    };

    if (pagedDataItem.id === '-1') {
      return this.http.post(provider.system + 'api/vacancy/get-vacancies-logged-user', { keyword: '' }, this.higherAuthSrevice.getHeader()).pipe(
        map((result: any) => {
          let pagedData = new PagedData();
          pagedData.items = result.vacancies.map((r: any) => {
            let item1 = new PagedDataItem();
            item1.id = r.vacancyId;
            item1.extraData = {}
            item1.title = r.title,
              item1.url = '/pages/vacancies/single/' + r.vacancyId + '?showTab=client&projectId=' + pagedDataItem.id;
            item1.getData = (nextPageToken) => this._getVacnacyCandidateData(provider, item1, nextPageToken);
            return item1;
          })
          return pagedData;
        })
      );
    }

    return this.http.post(provider.system + '/api/Project/get-vacancies', data, this.higherAuthSrevice.getHeader()).pipe(
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.vacancies.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.vacancyId;
          item1.extraData = {}
          item1.title = r.title,
            item1.url = '/pages/vacancies/single/' + r.vacancyId + '?showTab=client&projectId=' + pagedDataItem.id;
          item1.getData = (nextPageToken) => this._getVacnacyCandidateData(provider, item1, nextPageToken);
          return item1;
        })
        return pagedData;
      })
    );

  }
  private _getVacnacyCandidateData(provider: DataProvider, pagedDataItem: PagedDataItem, nextPageToken?: any) {
    const data = {
      keyword: '',
      pageNumber: 1,
      pageSize: 1000,
      vacancyId: pagedDataItem.id
    };
    return this.http.post(provider.system + '/api/jobapplication/get-jobApplications-by-vacancyId', data, this.higherAuthSrevice.getHeader()).pipe(
      map((result: any) => {
        let pagedData = new PagedData();
        pagedData.items = result.map((r: any) => {
          let item1 = new PagedDataItem();
          item1.id = r.id;
          item1.extraData = {}
          item1.title = r.name,
            item1.url = '/pages/candidates/single/' + r.id;
          return item1;
        })
        return pagedData;
      })
    );
  }




  openUrl(url: string, context: any): any {
    if (url === '/pages/client') {
      //asdf
    }
  }
}